export const API_BASE = process.env.NODE_ENV === 'production' ?
    `https://us-central1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net/widgets` :
    `http://127.0.0.1:5001/engagement-enhancers/us-central1/widgets`